import React from 'react';
import PropTypes from 'prop-types';

export const wasteTypes = [
  { id: '0A6B8696-3D53-4F60-BC2D-54FE46A2BF12', label: 'General Waste', image: '/waste-types/general-waste.jpg' },
  { id: '91AA4D14-28C9-4BB9-982C-C31AF73144D6', label: 'Green Waste', image: '/waste-types/green-waste.jpg' },
  { id: 'F6D2BFCF-884E-4E1B-82CF-267258EA18E7', label: 'Construction Waste', image: '/waste-types/construction-waste.jpg' },
];

const WasteInformationStep = ({ formData, handleInputChange, errors }) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium mb-4">Type of Waste</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {wasteTypes.map((type) => (
            <label key={type.id} className="flex flex-col items-center p-4 border rounded-lg cursor-pointer">
              <img src={type.image} alt={type.label} className="w-full h-32 object-cover mb-2 rounded" />
              <div className="flex items-center">
                <input
                  type="radio"
                  name="wasteTypeId"
                  value={type.id}
                  checked={formData.wasteTypeId === type.id}
                  onChange={handleInputChange}
                  className="mr-2"
                />
                <span>{type.label}</span>
              </div>
            </label>
          ))}
        </div>
        {errors.wasteTypeId && <p className="text-red-500 mt-1">{errors.wasteTypeId}</p>}
      </div>

      <div>
        <h3 className="text-lg font-medium mb-4">Hazardous Materials</h3>
        <div className="flex items-center space-x-4">
          <label className="flex items-center">
            <input
              type="radio"
              name="isHazardous"
              value="false"
              checked={!formData.isHazardous}
              onChange={() => handleInputChange({ target: { name: 'isHazardous', value: false } })}
              className="mr-2"
            />
            <span>No</span>
          </label>
          <label className="flex items-center">
            <input
              type="radio"
              name="isHazardous"
              value="true"
              checked={formData.isHazardous}
              onChange={() => handleInputChange({ target: { name: 'isHazardous', value: true } })}
              className="mr-2"
            />
            <span>Yes</span>
          </label>
        </div>
        {errors.isHazardous && <p className="text-red-500 mt-1">{errors.isHazardous}</p>}

        {formData.isHazardous && (
          <div className="mt-4">
            <label htmlFor="hazardousMaterials" className="block text-sm font-medium text-gray-700">
              Please list the hazardous materials:
            </label>
            <textarea
              id="hazardousMaterials"
              name="hazardousMaterials"
              value={formData.hazardousMaterials}
              onChange={handleInputChange}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm"
              rows="3"
            ></textarea>
            {errors.hazardousMaterials && <p className="text-red-500 mt-1">{errors.hazardousMaterials}</p>}
          </div>
        )}
      </div>
    </div>
  );
};

WasteInformationStep.propTypes = {
  formData: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};

export default WasteInformationStep;